import { action } from "typesafe-actions";

import { message } from "antd";

import {
  DateRangePayload,
  GatePayload,
  IataPayload,
  OrderingPayload,
  PaginatedResponse,
  PaginationPayload,
  ReportPayload,
  SearchPayload,
} from "../common_types";
import { CurrencyPayload } from "../currencies/types";
import { MarketPayload } from "../markets/types";

import { AuctionActionTypes, AuctionItem, AuctionItemByIata } from "./types";

export const tableFetchRequest = (
  payload: DateRangePayload &
    PaginationPayload &
    MarketPayload &
    CurrencyPayload &
    OrderingPayload &
    GatePayload &
    SearchPayload
) => action(AuctionActionTypes.TABLE_FETCH_REQUEST, payload);

export const tableFetchSuccess = (payload: PaginatedResponse<AuctionItem>) =>
  action(AuctionActionTypes.TABLE_FETCH_SUCCESS, payload);

export const tableFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(AuctionActionTypes.TABLE_FETCH_ERROR);
};

export const iataFetchRequest = (
  payload: DateRangePayload & MarketPayload & CurrencyPayload & GatePayload & IataPayload
) => action(AuctionActionTypes.IATA_FETCH_REQUEST, payload);

export const iataFetchSuccess = (payload: { iata: string; items: AuctionItemByIata[] }) =>
  action(AuctionActionTypes.IATA_FETCH_SUCCESS, payload);

export const iataFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(AuctionActionTypes.IATA_FETCH_ERROR);
};

export const reportGeneratorTaskCreateRequest = (
  payload: ReportPayload &
    DateRangePayload &
    MarketPayload &
    CurrencyPayload &
    OrderingPayload &
    GatePayload &
    SearchPayload
) => action(AuctionActionTypes.GENERATE_REPORT_REQUEST, payload);
